var _style, _path, _path2, _circle, _path3, _polygon, _path4, _ellipse, _path5, _path6, _path7, _path8, _path9, _circle2, _path10, _path11, _ellipse2, _path12, _polygon2, _rect, _path13, _rect2, _rect3, _rect4, _rect5, _circle3, _circle4, _rect6, _circle5, _rect7, _polygon3, _circle6, _rect8, _rect9, _circle7, _rect10, _rect11, _rect12, _rect13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b092779a-c5a4-43c0-bfaf-70dac86c4f75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 827.8 662.5",
    style: {
      enableBackground: "new 0 0 827.8 662.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E6E6;}\n\t.st1{fill:#2F2E41;}\n\t.st2{fill:#575A89;}\n\t.st3{fill:#FFB8B8;}\n\t.st4{opacity:0.2;enable-background:new    ;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#797BF2;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "progress_overview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M827.8,644.2c-5.2,25.4-275.9,23.3-275.5,0C557.4,618.7,828.2,620.9,827.8,644.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.9,579.3c-1.2,5.7-61.8,5.2-61.8,0C460.3,573.6,521,574.1,520.9,579.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 677.5,
    cy: 189.9,
    r: 18.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M658.7,182.2l11.8-2.9c16.8,0,30.5-13.6,30.5-30.5c0-2-0.2-4.1-0.6-6.1l0,0c0-22-17.8-39.8-39.8-39.8h0 c-22,0-39.8,17.8-39.8,39.8c0,0,0,0,0,0v0c-4.8,16.8,4.9,34.3,21.7,39.1C647.7,183.4,653.3,183.5,658.7,182.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "734.8,303.4 705.5,261.7 689.6,291.2 707.8,312.4 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M719.5,299.2c0,0,9.1-3.8,14.4,3s14.4,21.2,11.3,23.4s-12.9-6.8-12.9-6.8L719.5,299.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7819 -0.6233 0.6233 0.7819 -42.621 530.2081)",
    className: "st3",
    cx: 736.5,
    cy: 326,
    rx: 6.8,
    ry: 12.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M749,404.3c0,0-1.5,48.4-6.8,76.4s3,128.6,3,128.6l-16.6,7.6L718,605.5c0,0,3.8-20.4-1.5-34.8 s-7.6-76.4-7.6-76.4l-9.1-83.2L749,404.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M687,418.7l-47.7,87l-43.1,79.4v16.6l-21.9-6.8l7.6-17.4c0,0,3.8-68.1,31-94.5l23.4-67.3L687,418.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M715.4,301.8h8.3c0,0,45.4,62,43.1,99.8l-65,26.5l-2.3-5.3c0,0-53.7,9.8-67.3-1.5l18.9-96.8l1.5-13.6 L715.4,301.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M736.2,608.5c0,0-10.6-13.6,2.3-14.4s12.9,7.6,12.9,7.6l28.7,19.7c0,0,47.7,17.4,13.6,22.7c0,0-14.4,3-32.5-3.8 c-10.9-4.1-22.4-6.4-34-6.8c0,0-16.6-0.8-16.6-9.1s8.1-22.7,8.1-22.7S731.6,610.8,736.2,608.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M572.8,589.6c0,0,25.7-5.3,26.5,4.5s0,26.5,0,26.5s-6.1,7.6-4.5,12.9s-3.8,21.9-21.9,19.7s-12.1-28-12.1-28 l12.1-29.5L572.8,589.6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 655.2,
    cy: 146.4,
    r: 25.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M672.3,160.4l0.4,43.5l-31-10.6c0,0,3.8-25,3-27.2L672.3,160.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M677.9,191c0,0-32.5-11.3-36.3-9.8s-5.3,9.8-5.3,9.8s-18.2-3.8-20.4,8.3s14.4,65,14.4,65l16.6,31 c0,0-8.3,12.9,6.1,17.4s66.6-9.8,66.6-9.8s9.1-10.6,0-10.6c0,0-3-9.8-6.1-12.1s2.3-6.1-0.8-6.8s-3-2.3-3-2.3s15.1-20.4,1.5-37.1 s-15.5-32.1-22.3-34.4S677.9,191,677.9,191z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3761 -0.9266 0.9266 0.3761 74.9807 840.5543)",
    className: "st3",
    cx: 661.7,
    cy: 364.6,
    rx: 6.8,
    ry: 12.9
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M627.2,197.1h-10.7c0,0-30.9,74.9-21.9,98.3s42.4,64.3,42.4,64.3s10.6,18.9,18.2,18.9s15.9-27.2,15.9-27.2 l-24.2-10.6l-28.7-52.9l13.6-40.8L627.2,197.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "710.1,270.8 726.7,300.3 723.7,301.8 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 687.8,
    y: 336,
    transform: "matrix(0.9685 -0.249 0.249 0.9685 -72.9526 183.3819)",
    className: "st4",
    width: 1.5,
    height: 88.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M624.6,136.2l4.5-8.3l6.8,4.6l0,0c1.4,2,3.7,3.1,6.1,3.1l23.8-0.5c2.2,0,4.2-1,5.6-2.6l0,0 c3.8,1.4,6.7,4.6,7.7,8.5l2.9,11.2v-37.8h-45.4L624.6,136.2z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 426.9,
    height: 550
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 70.6,
    className: "st5",
    width: 403.2,
    height: 137.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 232.1,
    className: "st5",
    width: 403.2,
    height: 137.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 393.6,
    className: "st5",
    width: 403.2,
    height: 137.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 404.3,
    cy: 21.5,
    r: 11.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48.8,
    cy: 301,
    r: 11.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 81.6,
    y: 291.9,
    className: "st0",
    width: 106.2,
    height: 18.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 249.6,
    cy: 301.5,
    r: 11.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 282.3,
    y: 292.5,
    className: "st0",
    width: 106.2,
    height: 18.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "410.2,17.2 408.6,15.6 404.3,19.9 400,15.6 398.4,17.2 402.7,21.5 398.4,25.7 400,27.3 404.3,23.1  408.6,27.3 410.2,25.7 405.9,21.5 "
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48.8,
    cy: 139.5,
    r: 11.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 102.5,
    y: 129.3,
    className: "st0",
    width: 286.8,
    height: 18.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 129.3,
    className: "st6",
    width: 257.5,
    height: 18.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48.8,
    cy: 462.4,
    r: 11.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 102.5,
    y: 452.3,
    className: "st0",
    width: 286.8,
    height: 18.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 452.3,
    className: "st6",
    width: 161.2,
    height: 18.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 81.6,
    y: 291.9,
    className: "st6",
    width: 33.6,
    height: 18.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 282.3,
    y: 292.5,
    className: "st6",
    width: 66.6,
    height: 18.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513.4,555.1c0.2,17.8-10.3,24.1-23.4,24.2c-0.3,0-0.6,0-0.9,0c-0.6,0-1.2,0-1.8-0.1 c-11.8-0.7-21-7.2-21.2-23.7c-0.2-17.1,21.5-39,23.1-40.6l0,0c0.1-0.1,0.1-0.1,0.1-0.1S513.2,537.3,513.4,555.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDark);
export default __webpack_public_path__ + "static/media/new-dark.e15f7ab8a1bc577205539b41f8dedd00.svg";
export { ForwardRef as ReactComponent };